import { PayloadAction } from '@reduxjs/toolkit';
import { DefaultFollowUpCloseFormState, EActionState, IAppointmentCombinedState, IFollowUpCloseFormState, IListValue } from 'models';

export interface IState {
	activityId: string;
	close: EActionState;
	open: boolean;
	followUps: IAppointmentCombinedState[];
	form: IFollowUpCloseFormState;
	init: EActionState;
	opportunityId: string;
	reasonCodes: IListValue[];
	onSuccess?: () => PayloadAction<any>;
}

export const initialState: IState = {
	activityId: '',
	close: EActionState.COMPLETED,
	open: false,
	followUps: [],
	form: DefaultFollowUpCloseFormState,
	init: EActionState.PENDING,
	opportunityId: '',
	reasonCodes: [],
	onSuccess: undefined
};
